// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view.authentication-view {
  background-color: var(--color-elevated-canvas);
  border: solid 1px var(--color-elevated-border);
  color: var(--color-elevated-text);
  font-size: 1.6rem;
  margin: 2rem auto 0;
  max-width: 40rem;
  padding: 2rem 3rem;
  text-align: left;
}
.view.authentication-view .button {
  font-size: 1.2rem;
  width: 10rem;
}
.view.authentication-view .button:hover {
  background-color: var(--color-elevated-canvas);
}
.view.authentication-view .button.sign-in {
  float: right;
  margin-left: 2rem;
}
.view.authentication-view .button.register, .view.authentication-view .button.done, .view.authentication-view .button.reload {
  float: right;
  margin-left: 2rem;
}
.view.authentication-view .button.register, .view.authentication-view .button.done, .view.authentication-view .button.reload, .view.authentication-view .button.sign-out {
  font-size: 1.1rem;
  width: 13rem;
}
.view.authentication-view .button.sign-out.confirm {
  color: var(--color-elevated-warn);
}
.view.authentication-view .title.title-no-access {
  margin-bottom: 0;
}
.view.authentication-view .help-no-access {
  color: var(--color-elevated-warn);
  font-size: 1rem;
  line-height: 1.5rem;
}
.view.authentication-view .cta {
  font-size: 1.2rem;
  line-height: 2.3rem;
  text-align: right;
}
.view.authentication-view .help, .view.authentication-view .extra {
  font-size: 1rem;
}
.view.authentication-view .help-divider {
  border: solid 0.1rem var(--color-elevated-border);
  clear: both;
  margin: 2rem 0;
}
.view.authentication-view .help-link-line {
  margin-bottom: 0.5rem;
}
.view.authentication-view .help-link {
  text-decoration: underline;
}
.view.authentication-view .help-link:hover {
  color: var(--color-elevated-text);
  cursor: pointer;
}
.view.authentication-view .help.extra {
  clear: both;
  margin-top: 1rem;
}
.view.authentication-view .legal-links {
  float: right;
  position: relative;
  top: 2rem;
  text-align: right;
  left: 3rem;
}
.view.authentication-view .logo.passkey {
  float: left;
}
.view.authentication-view .sign-in .logo.passkey {
  left: 6rem;
}
.view.authentication-view .register-passkey .logo.passkey {
  left: 0rem;
}
.view.authentication-view .logo.qci {
  display: block;
  fill: var(--color-emphasis-text);
  height: 5rem;
  margin: 1rem auto 2rem;
  opacity: 1;
}
.view.authentication-view .registration-identifier-help {
  font-size: 1rem;
  font-style: italic;
  margin: -1.5rem 0 2rem;
  padding: 0 1rem;
}
.view.authentication-view .registration-identifier-input {
  position: relative;
  top: -0.05rem;
  width: 28.5rem;
}
.view.authentication-view .status-area {
  height: 2rem;
}
.view.authentication-view .status-cta {
  color: var(--color-elevated-text);
}
.view.authentication-view .status-error {
  color: var(--color-elevated-warn);
}
.view.authentication-view .status-normal {
  color: var(--color-elevated-hint);
}
.view.authentication-view .status-success {
  color: var(--color-elevated-success);
}
.view.authentication-view .step {
  margin-top: 1rem;
}
.view.authentication-view .steps-header {
  font-size: 1.3rem;
  font-weight: normal;
}
.view.authentication-view .step-number, .view.authentication-view .step-completed {
  border: solid 0.15rem var(--color-base-draw);
  border-radius: 50%;
  display: inline-block;
  font-size: 1rem;
  line-height: 2rem;
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
  text-align: center;
}
.view.authentication-view .step-completed {
  display: none;
  background-color: var(--color-base-hint);
}
.view.authentication-view .step.completed .step-number {
  display: none;
}
.view.authentication-view .step.completed .step-completed {
  display: inline-block;
}
.view.authentication-view .title {
  font-size: 1.5rem;
  font-weight: lighter;
  margin-bottom: 3rem;
  text-align: center;
}
.view.authentication-view .title .elevated {
  font-size: 1.6rem;
  font-weight: normal;
  margin: 0 0.1rem;
}`, "",{"version":3,"sources":["webpack://./src/style/views/authentication.scss"],"names":[],"mappings":"AAAA;EACE,8CAAA;EACA,8CAAA;EACA,iCAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AACF;AACE;EACE,iBAAA;EACA,YAAA;AACJ;AACI;EACE,8CAAA;AACN;AAGE;EACE,YAAA;EACA,iBAAA;AADJ;AAIE;EACE,YAAA;EACA,iBAAA;AAFJ;AAKE;EACE,iBAAA;EACA,YAAA;AAHJ;AAME;EACE,iCAAA;AAJJ;AAOE;EACE,gBAAA;AALJ;AAOE;EACE,iCAAA;EACA,eAAA;EACA,mBAAA;AALJ;AAQE;EACE,iBAAA;EACA,mBAAA;EACA,iBAAA;AANJ;AASE;EACE,eAAA;AAPJ;AAUE;EACE,iDAAA;EACA,WAAA;EACA,cAAA;AARJ;AAWE;EACE,qBAAA;AATJ;AAYE;EACE,0BAAA;AAVJ;AAWI;EACE,iCAAA;EACA,eAAA;AATN;AAaE;EACE,WAAA;EACA,gBAAA;AAXJ;AAcE;EACE,YAAA;EACA,kBAAA;EAAoB,SAAA;EACpB,iBAAA;EACA,UAAA;AAXJ;AAcE;EACE,WAAA;AAZJ;AAeE;EACE,UAAA;AAbJ;AAgBE;EACE,UAAA;AAdJ;AAiBE;EACE,cAAA;EACA,gCAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;AAfJ;AAkBE;EACE,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAhBJ;AAmBE;EACE,kBAAA;EAAoB,aAAA;EACpB,cAAA;AAhBJ;AAmBE;EACE,YAAA;AAjBJ;AAoBE;EACE,iCAAA;AAlBJ;AAqBE;EACE,iCAAA;AAnBJ;AAsBE;EACE,iCAAA;AApBJ;AAuBE;EACE,oCAAA;AArBJ;AAwBE;EACE,gBAAA;AAtBJ;AAyBE;EACE,iBAAA;EACA,mBAAA;AAvBJ;AA0BE;EACE,4CAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EAAmB,WAAA;EAAa,YAAA;EAChC,oBAAA;EACA,kBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,wCAAA;AAvBJ;AA2BI;EACE,aAAA;AAzBN;AA2BI;EACE,qBAAA;AAzBN;AA6BE;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AA3BJ;AA6BI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AA3BN","sourcesContent":[".view.authentication-view {\n  background-color: var(--color-elevated-canvas);\n  border: solid 1px var(--color-elevated-border);\n  color: var(--color-elevated-text);\n  font-size: 1.6rem;\n  margin: 2rem auto 0;\n  max-width: 40rem;\n  padding: 2rem 3rem;\n  text-align: left;\n\n  .button {\n    font-size: 1.2rem;\n    width: 10rem;\n\n    &:hover {\n      background-color: var(--color-elevated-canvas);\n    }\n  }\n\n  .button.sign-in {\n    float: right;\n    margin-left: 2rem;\n  }\n\n  .button.register, .button.done, .button.reload {\n    float: right;\n    margin-left: 2rem;\n  }\n\n  .button.register, .button.done, .button.reload, .button.sign-out {\n    font-size: 1.1rem;\n    width: 13rem;\n  }\n\n  .button.sign-out.confirm {\n    color: var(--color-elevated-warn);\n  }\n\n  .title.title-no-access {\n    margin-bottom: 0;\n  }\n  .help-no-access {\n    color: var(--color-elevated-warn);\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n\n  .cta {\n    font-size: 1.2rem;\n    line-height: 2.3rem;\n    text-align: right;\n  }\n\n  .help, .extra {\n    font-size: 1rem;\n  }\n\n  .help-divider {\n    border: solid 0.1rem var(--color-elevated-border);\n    clear: both;\n    margin: 2rem 0;\n  }\n\n  .help-link-line {\n    margin-bottom: 0.5rem;\n  }\n\n  .help-link {\n    text-decoration: underline;\n    &:hover {\n      color: var(--color-elevated-text);\n      cursor: pointer;\n    }\n  }\n\n  .help.extra {\n    clear: both;\n    margin-top: 1rem;\n  }\n\n  .legal-links {\n    float: right;\n    position: relative; top: 2rem;\n    text-align: right;\n    left: 3rem;\n  }\n\n  .logo.passkey {\n    float: left;\n  }\n\n  .sign-in .logo.passkey {\n    left: 6rem;\n  }\n\n  .register-passkey .logo.passkey {\n    left: 0rem;\n  }\n\n  .logo.qci {\n    display: block;\n    fill: var(--color-emphasis-text);\n    height: 5rem;\n    margin: 1rem auto 2rem;;\n    opacity: 1;\n  }\n\n  .registration-identifier-help {\n    font-size: 1rem;\n    font-style: italic;\n    margin: -1.5rem 0 2rem;\n    padding: 0 1rem;\n  }\n\n  .registration-identifier-input {\n    position: relative; top: -0.05rem;\n    width: 28.5rem;\n  }\n\n  .status-area {\n    height: 2rem;\n  }\n\n  .status-cta {\n    color: var(--color-elevated-text);\n  }\n\n  .status-error {\n    color: var(--color-elevated-warn);\n  }\n\n  .status-normal {\n    color: var(--color-elevated-hint);\n  }\n\n  .status-success {\n    color: var(--color-elevated-success);\n  }\n\n  .step {\n    margin-top: 1rem;\n  }\n\n  .steps-header {\n    font-size: 1.3rem;\n    font-weight: normal;\n  }\n\n  .step-number, .step-completed {\n    border: solid 0.15rem var(--color-base-draw);\n    border-radius: 50%;\n    display: inline-block;\n    font-size: 1rem;\n    line-height: 2rem; width: 2rem; height: 2rem;\n    margin-right: 0.5rem;\n    text-align: center;\n  }\n\n  .step-completed {\n    display: none;\n    background-color: var(--color-base-hint);\n  }\n\n  .step.completed {\n    .step-number {\n      display: none;\n    }\n    .step-completed {\n      display: inline-block;\n    }\n  }\n\n  .title {\n    font-size: 1.5rem;\n    font-weight: lighter;\n    margin-bottom: 3rem;\n    text-align: center;\n\n    .elevated {\n      font-size: 1.6rem;\n      font-weight: normal;\n      margin: 0 0.1rem;\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
